import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum WalletType {
	Fritidskortet = 'fritidskortet',
}

export enum WalletStatus {
	Active = 'active',
	Inactive = 'inactive',
}

export interface Wallet extends Record, Dateable {
	groupId: number;
	walletType: WalletType;
	currencyCode: string;
	status: WalletStatus;
	enabled: boolean;
}

export enum FritidskortetGiroType {
	Bankgiro = 'BG',
	Plusgiro = 'PG',
}

export enum FritidskortetVerifyStatus {
	Approved = 'GODKAND',
	Rejected = 'EJ_GODKAND',
	InvalidGiro = 'FELAKTIGT_GIRO',
}

export interface FritidskortetWalletConfig extends Record, Dateable {
	groupWalletId: number;
	organizationNumber: string;
	giro: string;
	giroType: FritidskortetGiroType;
	ocrControlLevel?: string;
	lastVerifiedStatus?: FritidskortetVerifyStatus;
	lastVerifiedAt?: number;
}

export interface FritidskortetSettings {
	groupWallet: Wallet;
	walletConfig: FritidskortetWalletConfig | null;
}

export interface FritidskortetVerifyResult {
	groupWallet: Wallet;
	walletConfig: FritidskortetWalletConfig;
}

export type FritidskortetErrorCode =
	| 'ej_godkand'
	| 'felaktigt_giro'
	| 'malformed_giro';

export interface FritidskortetErrorResponse {
	code: FritidskortetErrorCode;
	message: string;
	settings?: FritidskortetVerifyResult;
}
